import React from 'react';

interface ContextType {
    instantQuote: {
        name: string;
        category_id: null | number;
        package_id: null | number;
        recalculate: boolean;
        recalculate_queue: any[];
        options: any[];
        prices: any[];
        order: {
            name: string;
            items: any[];
        };
    };

    dispatch(data: { type: string; payload: any }): void;
}

export const InstantQuoteContext = React.createContext<ContextType>(null as any);
